module.exports = __webpack_public_path__ + "media/images/boxes/pup-box143-6551bfb65d3dc997e54724d92d02853a.png";